import { render, staticRenderFns } from "./extra-editor.vue?vue&type=template&id=1a13a17c"
import script from "./extra-editor.vue?vue&type=script&lang=js"
export * from "./extra-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports